import { PayloadAction, createSlice } from "@reduxjs/toolkit";
const quickActionsSlice = createSlice({
  name: "quickActions",
  initialState: () => {
    const initialState = {
      isLoginSuccess:false
};
    return initialState;
  },
  reducers: {
    setIsLoginSuccess(state, action: PayloadAction<boolean>) {
      state.isLoginSuccess = action.payload;
      return state;
    }
  },
});
 
export const {
  setIsLoginSuccess
} = quickActionsSlice.actions;
 
export default quickActionsSlice;